import React, { useEffect, useState } from "react";
import searcher from "../../../assets/searchInput.svg";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import PharmacyProductRequestTable from "./pharmacyproductRequestTable";

const PharmacyProductOfferRequestList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const search = queryParamsData.get("search") ?? "";

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/customers/pharmacy-product-offer-request",
      breadcrumb: " / customers / pharmacy PRODUCT OFFERS",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <div className="products-page">
      <div className="products-main-div">
        <div className="mx-3">
          {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))}
        </div>
        <div className="products-main-list my-2 py-1 d-flex justify-content-between flex-column">
          <div className="">
            <div className="search-container d-flex justify-content-between align-items-center w-100">
              <div className="search-box d-flex align-items-center p-2 ms-3 m-1 mb-2">
                <img className="styled-SVG" src={searcher} alt="o" />
                <input
                  value={search}
                  className="search-input text-dark fw_400 px-2"
                  type="text"
                  placeholder="Search Pharmacy Code, Name etc,."
                  onChange={(e) => {
                    navigate(
                      `/customers/pharmacy-product-offer-request?page=1${
                        e.target.value ? `&search=${e.target.value}` : ""
                      }`
                    );
                  }}
                />
              </div>
              <button
                onClick={() =>
                  navigate(`/customers/pharmacy-product-offer-request`)
                }
                className="py-2 border-0 rounded-2 mx-2 px-3 fs_14 Medium_Purple"
              >
                Clear Filters
              </button>
            </div>

            <PharmacyProductRequestTable search={search} page_no={page_no} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PharmacyProductOfferRequestList;
